import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "AccountRegister" })
export default class AccountRegister extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public options: any = null;
    public formData: any = {};
    public validationErrors: any[] = [];

    @Prop() readonly returnUrl: string;
    @Prop() readonly recaptchaSiteKey: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.options = (await Axios.post(this.routes.Account_GetOptions, null)).data;

        this.setRecaptcha();
    }

    public setRecaptcha() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            let result = (await Axios.post(this.routes.Account_Register, this.formData, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } })).data;

            this.isSuccess = true;

            GTagHelper.sendCustomEvent("sign_up", { method: "On Site" });

            window.location.href = result.redirectUrl ? result.redirectUrl : (this.returnUrl ? this.returnUrl : "/");
        } catch (error) {
            this.formData.password = null;
            this.formData.passwordCheck = null;

            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }

            (<any>window).grecaptcha.reset();
        }

        this.isLoading = false;
    }

    public setExternaAnalytics() {
        GTagHelper.sendCustomEvent("sign_up", { method: "Google" });
    }

    public isEmailInUse(): boolean {
        return (this.validationErrors.length !== 0 && this.validationErrors.some(x => x.message === this.localizer.get("Account.Common.Email_InUse")));
    }
};